import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { SiteHeader } from "@/components/site/SiteHeader";
import { SiteFooter } from "@/components/site/SiteFooter";
import { PlansTeaser } from "@/components/site/PlansTeaser";

import { pageSchemas } from "@/lib/seo/page-schema";
export const Route = createFileRoute("/pricing")({
  head: () => ({
    meta: [
      { title: "Pricing - Media Monitoring Platform | Perceptica" },
      { name: "description", content: "Custom pricing for Perceptica's media monitoring platform and media monitoring services - tailored to your brands, languages and markets across SEE." },
      { property: "og:title", content: "Pricing - Media Monitoring Platform | Perceptica" },
      { property: "og:description", content: "Custom pricing for Perceptica's media monitoring platform and media monitoring services - tailored to your brands, languages and markets across SEE." },

      ...ogImageMeta("en", "/pricing", "Perceptica media monitoring pricing"),
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Pricing - Media Monitoring Platform | Perceptica" },
      { name: "twitter:description", content: "Custom pricing for Perceptica's media monitoring platform and media monitoring services - tailored to your brands, languages and markets across SEE." },
      { property: "og:url", content: "https://perceptica.com/pricing" },
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "en", path: "/pricing" }),
  }),
  component: PricingPage,
});

function PricingPage() {
  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <main id="main">
        <section className="border-b border-border/60 bg-secondary/40 py-20 lg:py-28">
          <div className="mx-auto max-w-[900px] px-6 text-center lg:px-10">
            <h1 className="font-display mt-4 text-[clamp(2.25rem,4vw,3.25rem)] font-medium text-foreground">
              A plan for every stage of your team
            </h1>
            <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-foreground/75">
              Pricing is shaped to the brands, markets and languages you cover. Tell us about your team and
              we can prepare a tailored quote. Most requests receive a reply from us within one business day.
            </p>
          </div>
        </section>
        <PlansTeaser />
      </main>
      <SiteFooter />
    </div>
  );
}
